import { dutchDate } from '@/_helpers'

export default {
  methods: {
    dutchDate(date) {
      return dutchDate(date)
    }
  }
}